import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a65aef5e9c9962a7c79be831a42c39c7cb from "./generated-0da293de-7cfb-455c-9d41-325835ee56f1.json";

import a12053c6d893cfc0148a72c986ed81616b from "./generated-49aeb10e-4b73-44ef-9bf0-efebe678ce13.json";

import a6fe5647447e706f827782d7fef03c364b from "./generated-34f1dde0-3a36-4f91-b980-86a3ee7c6a2e.json";

import aea974f638496df87f83a091ab30d4981b from "./generated-2a864c6e-3727-4f47-b8d3-5d5dd6221fb2.json";

import a4c36ef01badd64cffd4e9d3dc9784f02b from "./generated-50b6ccf7-9789-4325-a364-d8d03493532e.json";

import a0b540171eb5b68cec833a1e43c8b3fe1b from "./generated-c332fa35-3345-47d9-af70-1069887c2f21.json";

import ae0fc874cd6532fba084e1848f9c7248eb from "./generated-e48adede-bb09-4237-8058-2507c9edde6f.json";

import adabe6123ceb12bc8aeb53f74902443acb from "./generated-2e31b3c4-03b8-44c4-90e1-c894155c0318.json";

import af354c916b2113253ac3644ad1afca028b from "./generated-1a08a165-e3bc-450f-9b6d-ef32870d4adc.json";

import abb07dfe7409f25771ac24b799c2228feb from "./generated-fc880572-42bd-4985-8cbf-cff1eb1dca23.json";

import a45147b06f966f0a2bc26e877e2d576a8b from "./generated-496a53ac-2212-455f-a035-8349d26f7ee2.json";

import a4aff31e5d4418fa00517c49982d59eecb from "./generated-24cd2bd5-dfd5-44d4-a69f-cb761a0573f5.json";

import af4d7c7edd8597c8ea7028fa9b5759eb0b from "./generated-c60554d5-9f80-40f3-b9ad-63576908ab81.json";

import abaeeb69231802a60a3ef757352c46cf1b from "./generated-dcf36b48-cfec-4d1e-b2ff-d77659a21657.json";

import af5add6b212eea04e1d025e5ac588c16cb from "./generated-13e23b33-9a04-499c-a079-3c67d866effd.json";

import aad838516e81b2d547487efdc741b7a27b from "./generated-bedf3a4d-c2cf-41a0-80de-36ec2245c22c.json";

import aa8682934cef7829660440c9048539d8ab from "./generated-1ede2681-54e9-493c-af80-2cbe1344af68.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a65aef5e9c9962a7c79be831a42c39c7cb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a12053c6d893cfc0148a72c986ed81616b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a6fe5647447e706f827782d7fef03c364b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aea974f638496df87f83a091ab30d4981b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a4c36ef01badd64cffd4e9d3dc9784f02b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a0b540171eb5b68cec833a1e43c8b3fe1b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ae0fc874cd6532fba084e1848f9c7248eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(adabe6123ceb12bc8aeb53f74902443acb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(af354c916b2113253ac3644ad1afca028b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(abb07dfe7409f25771ac24b799c2228feb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a45147b06f966f0a2bc26e877e2d576a8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4aff31e5d4418fa00517c49982d59eecb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af354c916b2113253ac3644ad1afca028b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(af4d7c7edd8597c8ea7028fa9b5759eb0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(abaeeb69231802a60a3ef757352c46cf1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(af354c916b2113253ac3644ad1afca028b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af5add6b212eea04e1d025e5ac588c16cb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(aad838516e81b2d547487efdc741b7a27b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aa8682934cef7829660440c9048539d8ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af5add6b212eea04e1d025e5ac588c16cb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */